/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

/** @module VsLogsModule */

import { Component, OnInit } from '@angular/core';

import { e2eTimingGroupByKeys } from 'ng/modules/vs-logs/constants/vs-logs-signpost.constants';

import {
    VirtualServiceStateService,
} from 'ng/modules/virtual-service/services/virtual-service-state.service';
import { VsLogsSignpostStore } from '../../vs-logs-signpost.store';
import './vs-logs-signpost-custom-e2e-timing.component.less';
import { getEndToEndTimingRequestParams } from '../../../../utils/vs-logs-signpost.utils';

/**
 * @description Signpost component for log signpost custom end to end timing section.
 * @author Suraj Kumar
 */
@Component({
    selector: 'vs-logs-signpost-custom-e2e-timing',
    templateUrl: './vs-logs-signpost-custom-e2e-timing.component.html',
})
export class VsLogsSignpostCustomEndToEndTimingComponent implements OnInit {
    /**
     * Reference to the virtual service item instance.
     */
    public readonly vs: any; // TODO AV-159345 update type.

    constructor(
        public readonly vsLogsSignpostStore: VsLogsSignpostStore,
        vsStateService: VirtualServiceStateService,
    ) {
        this.vs = vsStateService.virtualService;
    }

    /** @override */
    public ngOnInit(): void {
        this.switchView(e2eTimingGroupByKeys.totalTime);
    }

    /**
     * Switch view for end to end timing signpost and get data for new field.
     */
    public switchView(key: string): void {
        const fullSignpostParams = getEndToEndTimingRequestParams(key, this.vs);

        this.vsLogsSignpostStore.getVsLogSignpostCombinedData(fullSignpostParams);
    }

    public trackbyIndex(index: number): number {
        return index;
    }
}
